var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(
                "\n                      " +
                  _vm._s(_vm.t("application.rental")) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t("application.rental", {}, "zh"),
                fieldname: "rental",
                name: "rental",
                required: "",
                value: "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("application.no_of_employees"))),
            ]),
            _vm._v(" "),
            _c("IntegerInput", {
              attrs: {
                fieldTitle: _vm.t("application.no_of_employees", {}, "zh"),
                fieldname: "noOfEmployees",
                name: "employees",
                required: "",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.feature_receivable_amount"))),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t("lead.feature_receivable_amount", {}, "zh"),
                fieldname: "receivableAmount",
                name: "receivableAmount",
                value: "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.monthly_salary"))),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t("lead.monthly_salary", {}, "zh"),
                fieldname: "salary",
                name: "salary",
                value: "",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.question_outstanding_amount"))),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t("lead.question_outstanding_amount", {}, "zh"),
                fieldname: "outstandingAmount",
                name: "outstandingAmount",
                value: "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.question_monthly_repayment"))),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t("lead.question_monthly_repayment", {}, "zh"),
                fieldname: "repayment",
                name: "repayment",
                value: "",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.monthly_income"))),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t("lead.monthly_income", {}, "zh"),
                fieldname: "digitalIncome",
                name: "digitalIncome",
                value: "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-6 col-xs-12" },
          [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.pos_system"))),
            ]),
            _vm._v(" "),
            _c("v-select", {
              attrs: {
                options: _vm.boolOptions,
                reduce: (option) => option.code,
                searchable: false,
                fieldTitle: _vm.t("lead.pos_system", {}, "zh"),
                fieldValue: _vm.hasPos,
                fieldname: "pos",
              },
              model: {
                value: _vm.hasPos,
                callback: function ($$v) {
                  _vm.hasPos = $$v
                },
                expression: "hasPos",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }